export interface Property {
  label: string;
  value: any;
}
export interface Item {
  id: string;
  properties: Property[];
}
export interface Prepared {
  columns: any[];
  dataSource: Record<string, any>[];
}

const slug = (s: string) => s.toLowerCase().replace(/\s+/g, '_');
const isDate = (v: string) => /^\d{4}-\d{2}-\d{2}/.test(v);
const DASH = '-';

const normalize = (v: any): string | number | null => {
  if (v === null || v === '' || v === undefined) return DASH;
  if (Array.isArray(v))
    return v
      .map((it) =>
        typeof it === 'object' ? it.label ?? JSON.stringify(it) : String(it),
      )
      .join(', ');
  if (typeof v === 'object') return v.label ?? JSON.stringify(v);
  return v;
};

export const prepareTable = (items: Item[], t?: (key: string) => string): Prepared => {
  const columnsMap = new Map<string, any>();
  const unique: Record<string, Set<string>> = {};

  const dataSource = items.map(({ id, properties }) => {
    const row: Record<string, any> = { id };

    properties.forEach(({ label, value }) => {
      const key = slug(label);
      const normalized = normalize(value);
      row[key] = normalized;
      (unique[key] ||= new Set()).add(String(normalized));

      if (!columnsMap.has(key)) {
        const render =
          typeof normalized === 'string' && isDate(normalized)
            ? (v: string) =>
              v === DASH ? DASH : new Date(v).toLocaleDateString()
            : undefined;

        columnsMap.set(key, {
          title: t ? t(key) || label : label,
          dataIndex: key,
          key,
          width: 160,
          ellipsis: true,
          render,
        });
      }
    });
    return row;
  });

  [...columnsMap.keys()].forEach((k) =>
    dataSource.forEach((r) => (r[k] = r[k] ?? DASH)),
  );

  columnsMap.forEach((col, key) => {
    const vals = [...(unique[key] ?? [])];
    if (vals.length && vals.length <= 20) {
      col.filters = vals.map((v) => ({ text: v, value: v }));
      col.onFilter = (value: string, record: any) => record[key] === value;
    }
  });

  return { columns: [...columnsMap.values()], dataSource };
};